import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['appCore']),

		userIsMember() {
			return this.profile.is_member
		},
		userChapters() {
			return this.profile.chapters
		},
		isBlocked() {
			return this.blockedStatus(
				this.pageBlockedName,
				this.pageBlockedName === 'threads' ? +this.$route.query.thread_menu_id : null,
				this.pageBlockedName === 'resources' ? (this.$route.query.advance ? 1 : 0) : null
			)
		},
		blockRole() {
			return this.blockedRole(
				this.pageBlockedName,
				this.pageBlockedName === 'threads' ? +this.$route.query.thread_menu_id : null,
				this.pageBlockedName === 'resources' ? (this.$route.query.advance ? 1 : 0) : null
			)
		},
	},
	methods: {
		blockedStatus(routeName, thread_menu_id, advanced_resources) {
			if (this.appCore === null) {
				return null
			}
			const pattern = /\/\/(.+)/
			let route
			if (!thread_menu_id && advanced_resources === null) {
				route = this.appCore.app_menu.find((item) => {
					const matches = item.url.match(pattern)
					return matches[1] === this.pageBlockedName
				})
			} else if (advanced_resources !== null) {
				route = this.appCore.app_menu.find((item) => {
					const matches = item.url.match(pattern)
					return (
						matches[1] === this.pageBlockedName &&
						(advanced_resources
							? item.params.enable_advanced
							: !item.params.enable_advanced)
					)
				})
			} else {
				route = this.appCore.app_menu.find((item) => {
					const matches = item.url.match(pattern)
					return (
						matches[1] === this.pageBlockedName &&
						item.params.thread_menu_id === thread_menu_id
					)
				})
			}
			if (route) {
				if (route.chapters && route.chapters.length) {
					let result = false
					route.chapters.forEach((chapter) => {
						if (this.userChapters.some((item) => item.chapter_id === chapter)) {
							result = true
						}
					})
					if (!result) {
						return true
					}
				}
				if (route.role !== null) {
					return (
						!!(this.userIsMember && !route.role) || !!(!this.userIsMember && route.role)
					)
				}
			}
			return false
		},
		blockedRole(routeName, thread_menu_id) {
			if (this.appCore === null) {
				return ''
			}
			const pattern = /\/\/(.+)/
			let route
			if (!thread_menu_id) {
				route = this.appCore.app_menu.find((item) => {
					const matches = item.url.match(pattern)
					return matches[1] === routeName
				})
			} else {
				route = this.appCore.app_menu.find((item) => {
					const matches = item.url.match(pattern)
					return matches[1] === routeName && item.params.thread_menu_id === thread_menu_id
				})
			}
			if (route.chapters && route.chapters.length) {
				let result = false
				route.chapters.forEach((chapter) => {
					if (this.userChapters.some((item) => item.chapter_id === chapter)) {
						result = true
					}
				})
				if (!result) {
					return 'subgroup-'
				}
			}
			return route.role ? '' : 'non-'
		},
	},
}
